// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const people: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="People Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [

    {
      id: 'vendors',
      title: <FormattedMessage id="vendors" />,
      type: 'collapse',
      icon: icons.vendor,
      children: [
        {
          id: 'vendor-list',
          title: <FormattedMessage id="vendor-list" />,
          type: 'item',
          url: '/apps/vendors/vendor-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-vendor',
          title: <FormattedMessage id="add-new-vendor" />,
          type: 'item',
          url: '/apps/vendors/add-new-vendor'
        }
      ]
    },
    {
      id: 'bees',
      title: <FormattedMessage id="bees" />,
      type: 'collapse',
      icon: icons.bees,
      children: [
        {
          id: 'bees-list',
          title: <FormattedMessage id="bees-list" />,
          type: 'item',
          url: '/apps/bees/bees-list',
          breadcrumbs: false
        },
        {
          id: 'AddNewBees',
          title: <FormattedMessage id="AddNewBees" />,
          type: 'item',
          url: '/apps/bees/AddNewBees'
        }
      ]
    },
    {
      id: 'staff',
      title: <FormattedMessage id="staff" />,
      type: 'collapse',
      icon: icons.staff,
      children: [
        {
          id: 'staff-list',
          title: <FormattedMessage id="staff-list" />,
          type: 'item',
          url: '/apps/staff/staff-list',
          breadcrumbs: false
        },
        {
          id: 'AddNewStaff',
          title: <FormattedMessage id="AddNewStaff" />,
          type: 'item',
          url: '/apps/staff/AddNewStaff'
        }
      ]
    },
  ]
};

export default people;
